import { css } from 'linaria';
import { styled } from 'linaria/react';

export const RelatedContainer = styled.div<{
  isVisible?: boolean;
}>`
  position: relative;
  padding-bottom: var(--space-150);
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
`;

export const carousel = css`
  @media (--only-mobile) {
    margin-left: -16px;
  }

  & > div {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(auto-fit, minmax(calc(50% - var(--space-75)), 1fr));

    @media (--only-mobile) {
      padding-left: var(--space-200);
    }

    @media (--only-tablet) {
      width: calc(100% + var(--space-700) + var(--space-700) + var(--space-150));
      padding-right: var(--space-550);
      padding-left: var(--space-800);
      margin-left: -64px;
    }
  }

  & [class*='fromDesktop'] {
    @media (--to-desktop) {
      display: none;
    }
  }

  &::after {
    min-width: 0;
    margin-left: 0;

    @media (--only-mobile) {
      display: none;
    }
  }
`;

export const carouselTablet = css`
  & > div {
    grid-template-columns: repeat(auto-fit, minmax(calc(33.33% - var(--space-75)), 1fr));
  }
`;

export const carouselContainerManyItems = css`
  width: calc(100% + var(--space-400));
`;

export const carouselContainer = css`
  @media (--from-desktop) {
    width: initial;
  }
`;

export const SkeletonRows = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SkeletonTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const titleSkeleton = css`
  width: 120px;
  height: var(--space-250);
  border-radius: var(--rounding-l);
`;

export const buttonSkeleton = css`
  width: var(--space-300);
  height: var(--space-300);
  border-radius: var(--rounding-l);
`;

export const serviceSkeleton = css`
  width: 136px;
  height: 164px;
  border-radius: var(--rounding-l);
  margin-right: var(--space-150);
`;

export const ServicesSkeletonRow = styled.div`
  margin-top: var(--space-175);
  display: flex;
  flex-direction: row;
  justify-content: start;
`;

export const moreTwoLinkList = css`
  &:last-of-type {
    margin-right: var(--space-175) !important;
    @media (--from-desktop) {
      margin-right: var(--space-250) !important;
    }
  }
`;

export const linkList = css`
  margin-right: var(--space-150);

  &:last-of-type {
    margin-right: 0;
  }
`;
